module.exports = __webpack_public_path__ + "img/slide03bullet02.f7e07003.png";